import React, { useEffect, useState } from 'react'
import { Button, Dialog, DialogContent, DialogTitle, TextField } from '@material-ui/core'
import { editGroup, editProfile } from '@auteco/services/snopServices'
import useStyles from './styles'

const DialogEdit = ({ type, item, functionSuccess, open, onClose }) => {
    const [name, setName] = useState('')
    const [description, setDescription] = useState()

    const classes = useStyles()

    const handleClose = () => {
        setName('')
        onClose()
    }

    const handleSuccess = () => {
        functionSuccess()
        handleClose()
    }

    const onSave = async () => {
        if (type === 'perfil') {
            const body = {
                id: item.id,
                nombre: name
            }
            const { id } = await editProfile({ params: body })
            if (id === 1) {
                handleSuccess()
            }
        }
        if (type === 'grupo') {
            const body = {
                id: item.id,
                nombre: name,
                descripcion: description
            }
            const { success } = await editGroup({ params: body })
            if (success === 1) {
                handleSuccess()
            }
        }
    }

    useEffect(() => {
        if (item) {
            setName(item.nombre)
        }
        if (item?.descripcion) {
            setDescription(item.descripcion)
        }
    }, [item, open])
    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Editar {type}</DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <TextField
                    label='Nombre'
                    value={name}
                    variant='outlined'
                    onChange={(e) => setName(e.target.value)}
                />
                {type === 'grupo' &&
                    <TextField
                        label='Descripción'
                        value={description}
                        variant='outlined'
                        multiline
                        minRows={4}
                        className={classes.descriptionTxt}
                        onChange={(e) => setDescription(e.target.value)}
                    />
                }
            </DialogContent>
            <div className={classes.btnsContainer}>
                <Button variant='contained' className={classes.saveBtn} onClick={onSave}>Guardar</Button>
                <Button variant='contained' className={classes.cancelBtn} onClick={handleClose}>Cancelar</Button>
            </div>
        </Dialog>
    )
}

export { DialogEdit }